export default function shortenString(str) {
	return str.length > 55 ? str.slice(0,55) + "..." : str;
}